import BaseComponent from './_BaseComponent'

/* FORM HELPER
---------------------------------------------------------------------------------------------------- */

export default class FormHelper extends BaseComponent {

    constructor($el, namespace) {
        super('FormHelper', $el, namespace)

        this.$refs.input.forEach(($input) => {
            $input.closest('.fui-field').classList.add('is-empty')
        })

        this.on()
    }


    bindHandlers() {
        this.inputHandler = e => this.onInput(e)
    }

    bindEvents() {
        this.addListeners(
            [this.$refs.input, 'input', this.inputHandler],
        )
    }



    /* Handlers
    --------------------------------------------------------- */

    // eslint-disable-next-line class-methods-use-this
    onInput(e) {
        const isEmpty = !e.currentTarget.value.length

        const $ctn = e.currentTarget.closest('.fui-field')
        $ctn.classList.toggle('is-empty', isEmpty)
    }

    /* Actions
    --------------------------------------------------------- */



    /* Values
    --------------------------------------------------------- */



}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
